export const enum StreamType {
  Webcam,
  Slides,
  Screenshare,
  Rtmp,
}

export enum PipPosition {
  Bottom = 'bottom',
  Top = 'top',
}
